export const SERVER_URL = "https://zomato-clone-api.onrender.com";